import auth from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
export const routes = [
// {
//   name: '首页',
//   key: 'index'
// },
{
  name: '广告管理',
  key: 'advert'
}, {
  name: '报名管理',
  key: 'enroll',
  children: [{
    name: '报名分类管理',
    key: 'enroll_category'
  }, {
    name: '班级管理',
    key: 'classes'
  }, {
    name: '报名项目管理',
    key: 'enroll_item'
  }, {
    name: '报名数据管理',
    key: 'enroll'
  }]
}, {
  name: '题库管理',
  key: 'question_bank',
  children: [{
    name: '部门管理',
    key: 'department'
  }, {
    name: '题库分类管理',
    key: 'question_type'
  }, {
    name: '题库管理',
    key: 'question_bank'
  }, {
    name: '习题管理',
    key: 'question_item'
  }, {
    name: '练题记录',
    key: 'practice_record'
  }]
}, {
  name: '模考管理',
  key: 'exam',
  children: [{
    name: '模考列表',
    key: 'exam/list'
  }, {
    name: '模考记录',
    key: 'exam/record'
  }]
}, {
  name: '就业管理',
  key: 'company',
  children: [{
    name: '招聘公告',
    key: 'notice'
  }, {
    name: '招聘管理',
    key: 'job',
    children: [{
      name: '岗位分类管理',
      key: 'job/position'
    }, {
      name: '地区管理',
      key: 'job/area'
    }, {
      name: '薪资范围管理',
      key: 'job/salary'
    }, {
      name: '企业管理',
      key: 'job/company'
    }, {
      name: '岗位管理',
      key: 'job/jobs'
    }]
  }, {
    name: '报名管理',
    key: 'job_record'
  }, {
    name: '企业入驻',
    key: 'company_apply'
  }]
}, {
  name: '用户管理',
  key: 'mini_user'
}, {
  name: '代理管理',
  key: 'agent_apply'
}, {
  name: '新闻管理',
  key: 'news'
}, {
  name: '佣金记录',
  key: 'commission_record'
}, {
  name: '提现申请',
  key: 'cash_out_record'
}, {
  name: '系统设置',
  key: 'setting'
}];
export const getName = (path, routes) => {
  return routes.find(item => {
    const itemPath = `/${item.key}`;
    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};
export const generatePermission = role => {
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};
  routes.forEach(item => {
    if (item.children) {
      item.children.forEach(child => {
        result[child.name] = actions;
      });
    }
  });
  return result;
};
const useRoute = userPermission => {
  const filterRoute = (routes, arr = []) => {
    if (!routes.length) {
      return [];
    }
    for (const route of routes) {
      const {
        requiredPermissions,
        oneOfPerm
      } = route;
      let visible = true;
      if (requiredPermissions) {
        visible = auth({
          requiredPermissions,
          oneOfPerm
        }, userPermission);
      }
      if (!visible) {
        continue;
      }
      if (route.children && route.children.length) {
        const newRoute = {
          ...route,
          children: []
        };
        filterRoute(route.children, newRoute.children);
        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({
          ...route
        });
      }
    }
    return arr;
  };
  const [permissionRoute, setPermissionRoute] = useState(routes);
  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission)]);
  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];
    if (first) {
      return first?.children?.[0]?.key || first.key;
    }
    return '';
  }, [permissionRoute]);
  return [permissionRoute, defaultRoute];
};
export default useRoute;